/* eslint-disable @typescript-eslint/naming-convention */
import { LottieType } from "@cart-client/components/common-header/components/helper";
import { HEADER_LOTTIE_ASSETS } from "@swiggy-private/core-ui";
import { Lottie } from "@swiggy-private/cart-types";

export const TOING_RTB_HEADER_LOTTIE_STORAGE_KEY = "cart_header_lottie_TOING_RTB";

export const DEFAULT_TOING_RTB_HEADER_LOTTIE: Lottie = {
    type: LottieType.MAIN,
    lottie_id: HEADER_LOTTIE_ASSETS.TOING_HEADER,
};

/** Header_new.json: ip 0, op 149 */
export const TOING_RTB_HEADER_LOTTIE_FRAMES = {
    initial: 0,
    final: 149,
};

/** Last 5 frames, same pattern as BoltStampLottieFinalStateFrames */
export const TOING_RTB_HEADER_LOTTIE_FINAL_STATE_FRAMES = {
    initial: 149,
    final: 149,
};
